/**
 * Event name constants for all LiveKit platform modules.
 * Used by LKBase and all subclasses.
 */
const LK_EVENTS = {
  // Connection lifecycle
  CONNECTED: 'connected',
  DISCONNECTED: 'disconnected',
  RECONNECTING: 'reconnecting',
  RECONNECTED: 'reconnected',

  // Participants
  PARTICIPANT_JOINED: 'participant:joined',
  PARTICIPANT_LEFT: 'participant:left',

  // Tracks
  TRACK_SUBSCRIBED: 'track:subscribed',
  TRACK_UNSUBSCRIBED: 'track:unsubscribed',
  TRACK_MUTED: 'track:muted',
  TRACK_UNMUTED: 'track:unmuted',
  LOCAL_TRACK_PUBLISHED: 'track:local:published',
  LOCAL_TRACK_UNPUBLISHED: 'track:local:unpublished',

  // Audio
  SPEAKING_CHANGED: 'speaking:changed',
  AUDIO_LEVEL: 'audio:level',

  // Screen share
  SCREENSHARE_STARTED: 'screenshare:started',
  SCREENSHARE_STOPPED: 'screenshare:stopped',

  // Data channels
  DATA_RECEIVED: 'data:received',
  DATA_SENT: 'data:sent',

  // Layout / UI
  LAYOUT_CHANGED: 'layout:changed',
  DEVICE_CHANGED: 'device:changed',

  // Errors
  ERROR: 'error'
};

module.exports = { LK_EVENTS };
